import { render } from "./ServiceDetailsPage.vue?vue&type=template&id=a41bdf90"
import script from "./ServiceDetailsPage.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__